import { useQuery } from 'react-query'
import { fetchTestCycles, TestCyclesParams } from 'api/tests'

export const useFetchTestCycles = (params: TestCyclesParams) => {
  return useQuery(['fetchTestCycles', params], fetchTestCycles(params))
}
